/**
 * @brisa/ui · OnboardingLayout
 *
 * Wrapper de telas de onboarding (3 passos). Reusa AuthLayout-like canvas
 * mas com progress bar do OnboardingStepHeader como header fixo.
 */
import * as React from 'react';

export interface OnboardingLayoutProps {
  children: React.ReactNode;
}

export function OnboardingLayout({ children }: OnboardingLayoutProps) {
  return (
    <main id="main-content" className="brisa-onboarding-layout">
      <a href="#main-content" className="brisa-skip-link">
        Saltar para o conteúdo
      </a>
      <div className="brisa-onboarding-layout__container">{children}</div>
    </main>
  );
}
